/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RegisterPublicApprover model module.
 * @module model/RegisterPublicApprover
 * @version V1
 */
class RegisterPublicApprover {
    /**
     * Constructs a new <code>RegisterPublicApprover</code>.
     * @alias module:model/RegisterPublicApprover
     * @param name {String} 
     * @param email {String} 
     * @param timeZone {String} 
     */
    constructor(name, email, timeZone) { 
        
        RegisterPublicApprover.initialize(this, name, email, timeZone);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, email, timeZone) { 
        obj['name'] = name;
        obj['email'] = email;
        obj['timeZone'] = timeZone;
    }

    /**
     * Constructs a <code>RegisterPublicApprover</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RegisterPublicApprover} obj Optional instance to populate.
     * @return {module:model/RegisterPublicApprover} The populated <code>RegisterPublicApprover</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RegisterPublicApprover();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('timeZone')) {
                obj['timeZone'] = ApiClient.convertToType(data['timeZone'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RegisterPublicApprover</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RegisterPublicApprover</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of RegisterPublicApprover.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['timeZone'] && !(typeof data['timeZone'] === 'string' || data['timeZone'] instanceof String)) {
            throw new Error("Expected the field `timeZone` to be a primitive type in the JSON string but got " + data['timeZone']);
        }

        return true;
    }


}

RegisterPublicApprover.RequiredProperties = ["name", "email", "timeZone"];

/**
 * @member {String} name
 */
RegisterPublicApprover.prototype['name'] = undefined;

/**
 * @member {String} email
 */
RegisterPublicApprover.prototype['email'] = undefined;

/**
 * @member {String} timeZone
 */
RegisterPublicApprover.prototype['timeZone'] = undefined;

/**
 * @member {String} password
 */
RegisterPublicApprover.prototype['password'] = undefined;






export default RegisterPublicApprover;

